<template>
    <div id="start_packet_header"
        class="start-packet-header">
        <b-row>
            <b-col cols="6"
                lg="3"
                id="start_packet_header_info"
                class="start-packet-header-info"
                v-for="(item, index) in informations" :key="index" v-if="item.position == 'block-1'">
                <div class="start-packet-header-info-element">
                    <p class="start-packet-header-info-label" v-html="item.label"></p>
                    <p class="start-packet-header-info-value" v-html="item.value"></p>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="6"
                lg="3"
                id="start_packet_header_info"
                class="start-packet-header-info"
                v-for="(item, index) in informations" :key="index" v-if="item.position == 'block-2'">
                <div class="start-packet-header-info-element">
                    <p class="start-packet-header-info-label" v-html="item.label"></p>
                    <p class="start-packet-header-info-value" v-html="item.value"></p>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        computed: {
            informations () {
                return {
                    1: {
                        label: 'My start package',
                        value: 'FND '  + this.$store.getters.user.position,
                        position: 'block-1',
                    },
                    2: {
                        label: 'My Direct bonus',
                        value: this.$store.getters.user.directBonusPosition + '%',
                        position: 'block-1',
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../assets/scss/_colors.scss';

    .start-packet-header-info{

        .start-packet-header-info-element{
            padding-bottom: 20px;
            margin-bottom: 30px;
            border-bottom: 3px solid $base1;
        }
    }

    .start-packet-header-update-element{
        display: block;
        position: relative;

        .start-packet-header-update-label{
            position: relative;
            color: $white;
            background-color: $base2;
            width: 60%;
            padding: 10px;
            font-weight: regular;
            line-height: 1;

            &:after{
                position: absolute;
                z-index: 1;
                top: 0;
                right: -15px;
                content: '';
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 33px 0 33px 15px;
                border-color: transparent transparent transparent $base2;
                transition: 200ms all linear;
            }
        }

        .start-packet-header-update-value{
            position: absolute;
            color: $white;
            background-color: $base1;
            width: 40%;
            height: 100%;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            padding: 10px;
            font-weight: regular;
            line-height: 1;
            font-size: 20px;
            text-align: center;
            text-transform: uppercase;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/start-packet/StartPacketHeader.vue